import { useRef, useState, useEffect, useCallback } from "react";

// ゲームの経過時間タイマー。
// 表示更新は 500ms 刻み、確定値（stop の戻り値）は開始時刻からの実時間差分で誤差なし。
export const useElapsedTime = () => {
  const [elapsedMs, setElapsedMs] = useState(0);
  const startAtRef = useRef<number | null>(null);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const clear = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const start = useCallback(() => {
    clear();
    startAtRef.current = Date.now();
    setElapsedMs(0);
    intervalRef.current = setInterval(() => {
      if (startAtRef.current != null) {
        setElapsedMs(Date.now() - startAtRef.current);
      }
    }, 500);
  }, []);

  // 計測を止めて確定値（ms）を返す。未開始なら 0
  const stop = useCallback((): number => {
    clear();
    const finalMs = startAtRef.current != null ? Date.now() - startAtRef.current : 0;
    setElapsedMs(finalMs);
    return finalMs;
  }, []);

  const reset = useCallback(() => {
    clear();
    startAtRef.current = null;
    setElapsedMs(0);
  }, []);

  useEffect(() => clear, []);

  return { elapsedMs, start, stop, reset };
};

// ms → mm:ss 表示（99:59 で頭打ち）
export const formatElapsed = (ms: number): string => {
  const totalSec = Math.min(Math.floor(ms / 1000), 99 * 60 + 59);
  const mm = String(Math.floor(totalSec / 60)).padStart(2, "0");
  const ss = String(totalSec % 60).padStart(2, "0");
  return `${mm}:${ss}`;
};
